
export default "/assets/clock-mini.35f57c11.svg"